var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleIc = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 42 42"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 13332"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.489 23.199h-5.738v-3.47h9.569c.038.27.1.548.114.828a10.32 10.32 0 0 1-1.945 7.176 8.77 8.77 0 0 1-5.492 3.36 10.24 10.24 0 0 1-7.857-1.458 9.76 9.76 0 0 1-4.383-6.636 9.87 9.87 0 0 1 2.065-8.21 9.75 9.75 0 0 1 6.175-3.624 9.86 9.86 0 0 1 6.231.87 9.6 9.6 0 0 1 2.31 1.631L24.79 16.31a2 2 0 0 1-.129-.1 5.6 5.6 0 0 0-3.955-1.463 6.336 6.336 0 0 0-6.045 4.7 6.42 6.42 0 0 0 4.745 7.978 6.23 6.23 0 0 0 4.44-.6 5.16 5.16 0 0 0 2.6-3.381c.021-.075.028-.152.043-.245",
  "data-name": "Path 5984"
}))));
export { SvgGoogleIc as ReactComponent };
export default __webpack_public_path__ + "static/media/google_ic.75188d7abbce66709462614c75f4c541.svg";